import React from 'react';
import Select from 'react-select';
import { ValueType } from 'react-select/lib/types';
import styled from 'styled-components';

import { OptionType } from 'models';

const SelectContainer = styled.div`
    align-self: center;
    margin: 10px;
`;

const style = {
  container: (base: any) => ({
    ...base,
    flex: 1,
    alignSelf: 'center'
  }),
  option: (provided: any) => ({
    ...provided,
    cursor: 'pointer'
  }),
  control: (provided: any) => ({
    ...provided,
    width: '250px',
    cursor: 'pointer',
    minWidth: '0px'
  }),
  dropdownIndicator: (base: any, state: any) => ({
    ...base,
    transition: 'all .2s ease',
    transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null
  })
};

interface IProps {
  title: string;
  items: OptionType[];
  unit: string;
  selectedValue?: string;
  onChange: (selectedOption: ValueType<OptionType>) => void;
}

const ListSelector: React.FC<IProps> = ({ items, onChange, unit, selectedValue, title }) => {
  const resolveValue = () => {
    if (selectedValue) return { label: (`${selectedValue} ${unit}`), value: selectedValue };
    else return { label: 'Select value', value: 'Select value' };
  };

  return (
    <SelectContainer>
      <small>{title}</small>
      <Select value={resolveValue() as OptionType} onChange={onChange} styles={style} options={items} />
    </SelectContainer>
  );
};

export default ListSelector;
